var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.status === 'Approved' ||
    _vm.status === 'Aktif' ||
    _vm.status === 'Active' ||
    _vm.status === 'Verified' ||
    _vm.status === 'Transferred' ||
    _vm.status === 'Assigne' ||
    _vm.status === 'Created' ||
    _vm.status === 'File Have Been Uploaded' ||
    _vm.status === 'Open'
  )?_c('a-tag',{attrs:{"color":"green"}},[_vm._v(_vm._s(_vm.status.toUpperCase()))]):(_vm.status === 'Release' || _vm.status === 'RELEASE')?_c('a-tag',{attrs:{"color":"green"}},[_vm._v(_vm._s(_vm.status.toUpperCase()))]):(_vm.status === 'Delivered' || _vm.status === 'Received')?_c('a-tag',{attrs:{"color":"blue"}},[_vm._v(_vm._s(_vm.status.toUpperCase()))]):(_vm.status === 'Done' || _vm.status === 'DONE')?_c('a-tag',{attrs:{"color":"blue"}},[_vm._v(_vm._s(_vm.status.toUpperCase()))]):(
    _vm.status === 'On Process' || _vm.status === 'Waiting' || _vm.status === 'Edited'
    || _vm.status === 'on delivery'
  )?_c('a-tag',{attrs:{"color":"orange"}},[_vm._v(_vm._s(_vm.status.toUpperCase()))]):(
    _vm.status === 'Rejected' ||
    _vm.status === 'Revised' ||
    _vm.status === 'Non Aktif' ||
    _vm.status === 'Non Active' ||
    _vm.status === 'Cancelled' ||
    _vm.status === 'Canceled' ||
    _vm.status === 'Refunded'
  )?_c('a-tag',{attrs:{"color":"red"}},[_vm._v(_vm._s(_vm.status == "Canceled" ? "Cancelled".toUpperCase() : _vm.status.toUpperCase()))]):(_vm.status === 'Draft')?_c('a-tag',[_vm._v(_vm._s(_vm.status.toUpperCase()))]):(_vm.status === 'Tutup' || _vm.status === 'Closed' || _vm.status === 'Close')?_c('a-tag',[_vm._v("CLOSED")]):(_vm.status === null)?_c('a-tag',{attrs:{"color":"red"}},[_vm._v("CORRUPT")]):_c('a-tag',{attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.status))])}
var staticRenderFns = []

export { render, staticRenderFns }